import React from "react";
import {
  MDBBtn,
  MDBListGroup,
  MDBListGroupItem,
  MDBRipple,
} from "mdb-react-ui-kit";
import { AiOutlineSearch } from "react-icons/ai";

import "../../css/ListSearchCard.css";

function ListSearchEntity({
  title,
  setEntityQuery,
  entityQuery,
  selectEntity,
  suggestionToQuery,
  entityList,
  clearEntityQuery,
}) {
  function scrollToDivWithOffset() {
    const someDiv = document.getElementById("entityTitle");
    if (someDiv) {
      const rect = someDiv.getBoundingClientRect();
      window.scrollBy(0, rect.top - 100);
      return;
    }
    window.scrollTo(0, document.body.scrollHeight);
  }

  const selectEntityCall = async (e) => {
    e.preventDefault();

    if (entityQuery !== "" && entityQuery !== " ") {
      selectEntity(e);
      clearEntityQuery(false);

      document.getElementById("entName").disabled = true;

      setTimeout(() => {
        scrollToDivWithOffset();
      }, 500);
      return;
    }

    clearEntityQuery(true);
  };

  return (
    <div className="searchCardDiv">
      <h1>{title}</h1>

      <div className="searchBoxDiv">
        <div>
          <input
            className="searchBox"
            placeholder="Please Select an Entity"
            id="entName"
            type="text"
            disabled={true}
            onChange={(e) => {
              setEntityQuery(e.target.value);
            }}
          />

          <button
            id="toggle"
            className="searchBoxCancel"
            color="none"
            onClick={() => clearEntityQuery(true)}
          >
            X
          </button>
        </div>
        <MDBBtn onClick={selectEntityCall} className="searchButton">
          Search
        </MDBBtn>
        <MDBBtn className="searchButtonIcon" onClick={selectEntityCall}>
          <AiOutlineSearch />
        </MDBBtn>
      </div>
      <div className="searchListContainer" id="searchList">
        <div className="searchListDiv">
          <MDBListGroup>
            {entityList &&
              entityList
                .filter((entity) => {
                  if (!entityQuery || entityQuery === " " || entityQuery === "")
                    return true;
                  else
                    return entity["alias name"]
                      .toLowerCase()
                      .includes(entityQuery.toLowerCase());
                })
                .map((entity, index) => {
                  return (
                    <MDBRipple key={index} className="searchListItem">
                      <MDBListGroupItem
                        key={index}
                        tag="a"
                        action
                        onClick={(e) => {
                          suggestionToQuery(
                            entity["entity id"],
                            entity["alias name"]
                          );
                          //setEntity(entity["entity id"]);
                        }}
                      >
                        {entity["alias name"]}
                      </MDBListGroupItem>
                    </MDBRipple>
                  );
                })}
          </MDBListGroup>
        </div>

        <MDBBtn className="searchButton" style={{ visibility: "hidden" }}>
          Search
        </MDBBtn>
        <MDBBtn className="searchButtonIcon" style={{ visibility: "hidden" }}>
          <AiOutlineSearch />
        </MDBBtn>
      </div>
    </div>
  );
}

export default ListSearchEntity;
